import { useEffect, useState } from "react";
import { SingleValue } from "react-select";
import Label from "../../../Label";
import ConfigSelect from "../../AddProduct/ConfigSelect";
import "./AddCategory.scss";

type Props = {
  categories: Category[];
  submitNewCategory: (newCategory: Category) => void;
};

const AddCategory: React.FC<Props> = ({ categories, submitNewCategory }) => {
  const emptyCategory = {
    value: "",
    label: "",
    department: "",
    description: false,
    ts: 0,
  };
  const [newCategory, setNewCategory] = useState<Category>(emptyCategory);
  const [checkedNewCategory, setCheckedNewCategory] = useState<boolean>(false);

  const handleChange = (e: any) => {
    setNewCategory({
      ...newCategory,
      [e.currentTarget.name]: e.currentTarget.value,
    });
  };

  useEffect(() => {
    newCategory.department != "" &&
    newCategory.label != "" &&
    newCategory.value != "" &&
    !categories.some(
      (cate) =>
        cate.department == newCategory.department &&
        cate.value == newCategory.value
    )
      ? setCheckedNewCategory(true)
      : setCheckedNewCategory(false);
  }, [newCategory]);

  const handleSelect = (
    selectedOption: SingleValue<{ value: string; label: string }>,
    e: any
  ) => {
    e.name == "description"
      ? setNewCategory({
          ...newCategory,

          description: selectedOption?.value == "true" ? true : false,
        })
      : setNewCategory({
          ...newCategory,
          [e.name]: selectedOption?.value,
        });
  };

  const handleSubmit = () => {
    submitNewCategory(newCategory);
  };

  return (
    <div className="addManufacturingCostContainer">
      <Label
        tag="h3"
        style={{
          textAlign: "left",
          fontFamily: "Mont-Semibold",
          marginBottom: "1.5rem",
        }}
      >
        Nueva Categoría
      </Label>
      <form className="addManufacturingCost" id="newCategory">
        <div className="addManufacturingCost__input-container">
          <Label tag="label" className="addManufacturingCost__label">
            Código
          </Label>
          <input
            type="text"
            placeholder="Ej. Solid"
            name="value"
            onChange={handleChange}
            value={newCategory.value}
          ></input>
        </div>
        <div className="addManufacturingCost__input-container ">
          <Label tag="label" className="addManufacturingCost__label">
            Nombre
          </Label>
          <input
            type="text"
            placeholder="Ej. Maciza"
            name="label"
            onChange={handleChange}
            value={newCategory.label}
          ></input>
        </div>

        <div className="addManufacturingCost__select-container">
          <ConfigSelect
            handleSelect={handleSelect}
            placeholder="Seleccionar..."
            value={{
              value: newCategory.department,
              label:
                newCategory.department === ""
                  ? "Seleccionar..."
                  : newCategory.department === "ring"
                  ? "Anillos"
                  : newCategory.department === "brazalete"
                  ? "Pulseras"
                  : newCategory.department === "chain"
                  ? "Cadenas"
                  : newCategory.department === "hoop"
                  ? "Aros"
                  : newCategory.department === "finding"
                  ? "Fornituras"
                  : "Dijes",
            }}
            options={[
              { value: "ring", label: "Anillos" },
              { label: "Pulseras", value: "brazalete" },
              { label: "Cadenas", value: "chain" },
              { label: "Dijes", value: "pendant" },
              { label: "Aros", value: "hoop" },
              { label: "Fornituras", value: "finding" },
            ]}
            productConfig="department"
            label="Departamento"
          />
        </div>
        <div className="addManufacturingCost__select-container">
          <ConfigSelect
            handleSelect={handleSelect}
            placeholder="Seleccionar..."
            value={{
              value: newCategory.description.toString(),
              label:
                newCategory.description.toString() === ""
                  ? "Seleccionar..."
                  : newCategory.description.toString() === "true"
                  ? "Con descripción"
                  : "Sin descripción",
            }}
            options={[
              { value: "true", label: "Con descripción" },
              { value: "false", label: "Sin descripción" },
            ]}
            productConfig="description"
            label="Descripción"
          />
        </div>
      </form>
      {checkedNewCategory ? (
        <button
          type="button"
          onClick={handleSubmit}
          className="addManufacturingCost_button"
        >
          Agregar
        </button>
      ) : (
        <div className="addCategory__buttons">
          {newCategory.department != "" &&
            newCategory.value != "" &&
            newCategory.label != "" && (
              <p>
                Combinación de código y departamento ya existente. Verifique los
                datos ingresados.
              </p>
            )}
          <button
            type="button"
            className="addManufacturingCost_button addManufacturingCost_button_disabled"
            disabled={true}
          >
            Agregar
          </button>
        </div>
      )}
    </div>
  );
};

export default AddCategory;
